import './CommentText.css'

const CommentText = ({ children }) => {
  return <p className='commentText'>{children}</p>
}

export default CommentText
